module.exports = __webpack_public_path__ + "img/research_iton_0.e3ee0336.png";